// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-Menu----menu-module---container---2PKyH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/menu.module.less
// module id = 268
// module chunks = 114276838955818